import React, { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalContext, ModalVariableTypes } from '../../contexts/ModalContext'
import i18n from '../../i18n'
import ModalWrapper from '../../wrappers/modalWrapper/ModalWrapper'
import BadgeComponent from './components/BadgeComponent'

const AllTiers: FC = () => {
	const { t } = useTranslation('modals_badges')
	const { currentModal } = useContext(ModalContext)

	const modalVariable = currentModal?.modalVariable as ModalVariableTypes['badges-tiers']
	const { tiers, categoryName } = modalVariable

	return (
		<ModalWrapper appBarOptions={{ label: categoryName }}>
			<div className='flex flex-col gap-4'>
				{tiers.map(tierData => (
					<div
						key={`${tierData.badge.id}-${tierData.tier.id}`}
						className='flex flex-row items-center gap-4'
					>
						<div className='w-1/3'>
							<BadgeComponent
								badge={tierData.badge}
								userBadge={tierData.userBadge}
								tier={tierData.tier}
								isCompleted={tierData.isCompleted}
								isClickable
							/>
						</div>

						<div className='flex flex-col gap-1'>
							<span className='font-semibold text-lg text-text-dark dark:text-white'>
								{i18n.language === 'en' ? tierData.tier.tierNameEn : tierData.tier.tierNameFi}
							</span>

							<span className='text-text-grey-200 dark:text-text-grey-100 text-sm'>
								{i18n.language === 'en'
									? tierData.tier.tierDescriptionEn
									: tierData.tier.tierDescriptionFi}
							</span>

							{tierData.isCompleted && tierData.userBadge && (
								<p className='text-text-grey-200 dark:text-text-grey-100 text-sm font-medium'>
									{tierData.userBadge.earnedCount > 1
										? t('timesEarnedPlural', { count: tierData.userBadge.earnedCount })
										: t('timesEarnedSingular')}
								</p>
							)}
						</div>
					</div>
				))}
			</div>
		</ModalWrapper>
	)
}

export default AllTiers
